import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Route, Routes, useSearchParams, Navigate, useLocation } from 'react-router-dom';
import classes from './App.module.css';
import Layout from './hoc/Layout/Layout';
import Login from './containers/Login/Login';
import Chat from './containers/Chat/Chat'
import * as actions from './store/actions/index';
import Disconnected from './components/UI/DisconnectedUser/Disconnected';

const App = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const location = useLocation(); // ✅ Use useLocation() instead of global location
  // const queryParams = Object.fromEntries(searchParams);

  const isLogged = useSelector(state => state.login.token) !== null
  const isAuthLoading = useSelector(state => state.login.loading)
  const isBtnLogginTouched = useSelector(state => state.login.isBtnLogginTouched)

  useEffect(() => {
    dispatch(actions.loginCheckState())
  }, [dispatch])

  const toShowLogOrDash = isLogged ? <Chat /> : <Login />;

  // ✅ Update Redux when the route changes
  useEffect(() => {
    const queryParams = Object.fromEntries(searchParams);
    const dashboardSection = location.pathname.includes("/dashboard/conv") ? "conv" : null;
    const pathParts = location.pathname.split("/").filter(Boolean); // Remove empty parts

    //     /crm/:name/:attribute/:value/edit
    // /crm/:name/:attribute/:value/view
    // /crm/:name/records
    // /crm/:name/settings/module-layout
    // /crm/:name/settings/grid-columns

    let [crm, name, attribute, value, mode] = pathParts;
    if (crm !== "crm") {
      name = attribute = value = mode =crm= null;
    }

    dispatch(actions.setRouteParams({ crm,name, attribute, value, mode }));
    dispatch(actions.updateQueryParams(queryParams));
    dispatch(actions.updateDashboardSection(dashboardSection));

    console.log("Redux updated with route changes:", { queryParams, dashboardSection });
  }, [location.pathname, searchParams, dispatch]);

  return (
    <Layout>
      <div className={classes.App}>
        {
          (!isAuthLoading || isBtnLogginTouched) &&
          <Routes>
            <Route path="/" element={toShowLogOrDash} />
            <Route path="/login" element={toShowLogOrDash} />
            <Route path="/dashboard" element={toShowLogOrDash} />
            <Route path="/dashboard/conv" element={toShowLogOrDash} />
            <Route path="/disconnected" element={<Disconnected />} />
            <Route path="/crm/:name/*" element={toShowLogOrDash} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        }
      </div>
    </Layout>
  )
}

export default App


// import React, { Component } from 'react';
// import { connect } from 'react-redux';
// import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// import classes from './App.module.css';
// import Login from './containers/Login/Login';
// import Layout from './hoc/Layout/Layout';
// import * as actions from './store/actions/index';
// import Chat from './containers/Chat/Chat'
// import AgentMsgSum from './containers/AgentMsgSum/AgentMsgSum';

// class App extends Component {
//   componentDidMount() {
//     this.props.loginCheckState()
//     //   this.props.onTryAutoSignup();
//   }

//   render() {
//     let routes = (
//       <Routes>
//         <Route path="/Login" element={<Login />} />
//         <Route path="*" element={<Navigate to="/Login" />} />
//       </Routes>
//     );
//     if (this.props.isAuthLoading && !this.props.isBtnLogginTouched) {
//       routes = undefined
//     }
//     if (this.props.isLogged) {
//       routes = (
//         <Routes>
//           <Route path="/Chat" element={<Chat />} />
//           <Route path="/AgentMsgSum" element={<AgentMsgSum />} />
//           <Route path="/" element={<Chat />} />
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       );
//     }

//     return (
//       <Layout>
//         <div className={classes.App}>
//           {routes}
//         </div>
//       </Layout>

//     );
//   };

// }

// const mapStateToProps = state => {
//   return {
//     isLogged: state.login.token !== null,
//     autoLogIn: state.login.autoLogIn,
//     isAuthLoading: state.login.loading,
//     isBtnLogginTouched: state.login.isBtnLogginTouched
//   };

// }

// const mapDispatchToProps = dispatch => {
//   return {
//     onLogout: () => dispatch(actions.logout()),
//     loginCheckState: () => dispatch(actions.loginCheckState())
//   }

// }


// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
